import { Grid, Tooltip } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import { IconEye, IconHeartFilled } from "@tabler/icons-react";
import MxIcons from "@rf-l1/MxIcons";

interface MxCPropertyStansProps {
  views?: number;
  likes?: number;
}
const MxCPropertyStans = ({ views = 0, likes = 0 }: MxCPropertyStansProps) => {
  return (
    <Grid container spacing={0.5} sx={{ cursor: "default" }} px={0.5} pr={1}>
      <Tooltip title="Me gusta">
        <Grid item xs={6} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <MxIcons
            color="error.main"
            sx={{ cursor: "default" }}
            children={<IconHeartFilled size={16} stroke={1.5} />}
          />
          <MxTypography variant="overline" color="primary.main" children={likes} />
        </Grid>
      </Tooltip>
      <Tooltip title="Vistas">
        <Grid item xs={6} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <MxIcons
            color="primary.main"
            sx={{ cursor: "default" }}
            children={<IconEye size={16} stroke={1.5} />}
          />
          <MxTypography variant="overline" color="primary.main" children={views} />
        </Grid>
      </Tooltip>
    </Grid>
  );
};

export default MxCPropertyStans;
